export default __webpack_public_path__ + "media/flags/sv-3186524c.svg";